import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const submitConsultation = (payload) => api.post("/consultation", payload).then((r) => r.data);

export const getAvailability = (date) =>
  api.get("/bookings/availability", { params: { date } }).then((r) => r.data);
export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);

export const submitRFP = (payload, files = [], onProgress) => {
  const fd = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") fd.append(k, v);
  });
  files.forEach((f) => fd.append("files", f));
  return api
    .post("/rfp", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    })
    .then((r) => r.data);
};

export const rfpFileUrl = (fileId) => `${API}/rfp/file/${fileId}`;

export const subscribeNewsletter = (email, source = "footer") =>
  api.post("/newsletter", { email, source }).then((r) => r.data);
